namespace JupitersChoice {
    export class AllReelsStoppedCmd {

        @inject('SpinModel') _spinModel: Sapphire.SpinModel;

        execute(): void {
            this._spinModel.spinEnded();
            Sapphire.Logger.log(`Spin duration ${this._spinModel.getSpinDuration() / 1000}s`)
        }
    }
}
